import React from 'react'
import pt from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash-es'

import Home from './Items/Home'
import Feeder from './Items/Feeder'
import Search from './Items/Search'
import Activities from './Items/Activities'
import Profile from './Items/Profile'

import ContextMenu from '../FeedContextMenu/MainMenuContextMenu'

import { openMod } from '../../modules/mods'
import Fade from '../Fade/Fade'

import './MainMenu.scss'

const MainMenu = ({ location: { pathname }, modals, user, feed, openMod, resetSearch }) => {
  const username = get(user, 'data.user.username')
  return (
    <div className="main-menu">
      <Home />
      <Feeder pathname={pathname} />
      <Search openMod={openMod} pathname={pathname} />
      {get(user, 'data.user.username') && (
        <Activities pathname={pathname} user={user} hasUnchecked={user.hasUncheckedActivities} />
      )}
      <div className="main-menu__profile">
        <Profile pathname={pathname} username={username} />
        <Fade mounted={!!username} time={150}>
          <ContextMenu />
        </Fade>
      </div>
    </div>
  )
}

MainMenu.propTypes = {
  openMod: pt.func.isRequired,
  location: pt.shape({ pathname: pt.string }),
  modals: pt.shape({}),
  user: pt.shape({}),
  feed: pt.shape({}),
  resetSearch: pt.func
}

export default connect(
  ({ location, modals, user, feed }) => ({
    location,
    modals,
    user,
    feed
  }),
  {
    openMod
  }
)(MainMenu)
